import React, { useState, useEffect, useRef } from 'react';
import '../../assets/styles/modal-member.css';

const ModalMember = ({ taskMembers, allMembers, onSelectMember, setIsModalOpen }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const modalRef = useRef(null);
    const searchInputRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setIsModalOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [setIsModalOpen]);

    const filteredMembers = allMembers
        .filter(member =>
            `${member.nombre} ${member.apellido}`.toLowerCase().includes(searchTerm.toLowerCase())
        )
        .sort((a, b) => {
            const isSelectedA = taskMembers.some(m => m.id_usuario === a.id_usuario);
            const isSelectedB = taskMembers.some(m => m.id_usuario === b.id_usuario);
            if (isSelectedA && !isSelectedB) return -1;
            if (!isSelectedA && isSelectedB) return 1;
            return 0;
        });

    return (
        <div className="modal-member" ref={modalRef} onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setIsModalOpen(false)} style={{color:"GrayText"}}>X</button>

            <div style={{marginTop:'20px'}}>
                <div>
                    <input 
                        ref={searchInputRef}
                        type="text" 
                        placeholder="Buscar usuario..." 
                        value={searchTerm} 
                        onChange={(e) => setSearchTerm(e.target.value)} 
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>
                <div>
                    <ul className="member-list">
                        {filteredMembers.map(member => (
                            <li 
                                key={member.id_usuario} 
                                onClick={() => onSelectMember(member.id_usuario)}
                                className={taskMembers.some(m => m.id_usuario === member.id_usuario) ? 'selected' : ''}
                            >
                                <img src={member.imgurl} alt={member.nombre} />
                                <div>
                                    <h4>{member.nombre} {member.apellido}</h4>
                                    <p>{member.unidad}</p>
                                </div>

                                {taskMembers.some(m => m.id_usuario === member.id_usuario) && <span className="assigned-icon">✓</span>}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ModalMember;
